import axios from 'axios';
import { AutocompleteItemType } from './searchAutocomplete.types';

let offsetCached: number;

export function autocomplete(
  query: string,
  index: number,
): Promise<{
  data: {
    completions: AutocompleteItemType[];
    index: number;
  };
}> {
  if (query.length === 0) {
    offsetCached = 0;
  }
  return axios
    .get('/api/autocomplete', {
      params: {
        q: query,
        offset: offsetCached,
      },
      disableParsing: true,
      withCredentials: true,
    })
    .then((response) => {
      offsetCached = response.data.offset;
      response.data.index = index;
      return response;
    });
}
